module.exports = __webpack_public_path__ + "static/img/60.8e9fdc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/60.jpg
// module id = vzHZ
// module chunks = 0